<template>
  <div :class="isMobile ? 'mobile' : 'pc'">
    <div class="content-box">
      <!-- PC端 -->
      <div v-if="!isMobile" class="pc">
        <!-- 首页 -->
        <HomePage
          v-if="activeNavTab === 'home'"
          @showFeedbackPopup="showFeedbackPopup"
          @showKolPopup="showKolPopup"
          @switchNavTab="switchNavTab"
          @gotoLogin="gotoLogin"
          @logout="logout"
        />

        <!-- UGC列表页面 -->
        <UgcPage
          v-if="activeNavTab === 'ugc'"
          @goBack="handleGoBack"
          @showCreatePopup="showCreatePopup"
          @showContentDetail="showContentDetail"
          @switchNavTab="switchNavTab"
          @showLoginTip="showLoginTip"
          @showTipMessage="showTipMessage"
          @jumpToWebsite="jumpToWebsite"
          @jumpToFacebook="jumpToFacebook"
          @jumpToDiscord="jumpToDiscord"
        />

        <!-- 创作中心页面 -->
        <CenterPage
          v-if="activeNavTab === 'center'"
          @goBack="handleGoBack"
          @showCreatePopup="showCreatePopup"
          @showContentDetail="showContentDetail"
          @switchNavTab="switchNavTab"
          @deleteCreation="deleteCreation"
          @previewImage="previewImage"
          @showLoginTip="showLoginTip"
          @jumpToWebsite="jumpToWebsite"
          @jumpToFacebook="jumpToFacebook"
          @jumpToDiscord="jumpToDiscord"
        />

        <!-- 意见反馈页面 -->
        <FeedbackPage
          v-if="activeNavTab === 'feedback'"
          @goBack="handleGoBack"
        />

        <!-- 开发日志页面 -->
        <DevelopmentPage
          v-if="activeNavTab === 'development'"
          @goBack="handleGoBack"
        />
      </div>
      <!-- 移动端 -->
      <div v-else class="mobile">
        <!-- 移动端顶部导航栏 -->
        <MobileTopNavbar
          :musicState="musicState"
          @switchMusic="switchMusic"
          @jumpLink="jumpLink"
          @scrollToTop="scrollToTop"
        />

        <!-- 首页 -->
        <HomePage
          v-if="activeNavTab === 'home'"
          @showFeedbackPopup="showFeedbackPopup"
          @showKolPopup="showKolPopup"
          @switchNavTab="switchNavTab"
          @gotoLogin="gotoLogin"
          @logout="logout"
        />

        <!-- UGC列表页面 -->
        <UgcPage
          v-if="activeNavTab === 'ugc'"
          @goBack="handleGoBack"
          @showCreatePopup="showCreatePopup"
          @showContentDetail="showContentDetail"
          @switchNavTab="switchNavTab"
          @showLoginTip="showLoginTip"
          @showTipMessage="showTipMessage"
          @jumpToWebsite="jumpToWebsite"
          @jumpToFacebook="jumpToFacebook"
          @jumpToDiscord="jumpToDiscord"
        />

        <!-- 创作中心页面 -->
        <CenterPage
          v-if="activeNavTab === 'center'"
          @goBack="handleGoBack"
          @showCreatePopup="showCreatePopup"
          @showContentDetail="showContentDetail"
          @switchNavTab="switchNavTab"
          @deleteCreation="deleteCreation"
          @previewImage="previewImage"
          @showLoginTip="showLoginTip"
          @jumpToWebsite="jumpToWebsite"
          @jumpToFacebook="jumpToFacebook"
          @jumpToDiscord="jumpToDiscord"
        />

        <!-- 意见反馈页面 -->
        <FeedbackPage
          v-if="activeNavTab === 'feedback'"
          @goBack="handleGoBack"
        />

        <!-- 开发日志页面 -->
        <DevelopmentPage
          v-if="activeNavTab === 'development'"
          @goBack="handleGoBack"
        />

        <!-- 移动端底部导航栏 (仅在 UGC 和 Center 页面显示) -->
        <MobileBottomNavbar
          :activeNavTab="activeNavTab"
          v-if="activeNavTab === 'ugc' || activeNavTab === 'center'"
          @switchNavTab="switchNavTab"
          @showCreatePopup="showCreatePopup"
        />

        <div class="top-btn" @click="scrollToTop"></div>
      </div>
    </div>

    <!-- 侧边栏组件 -->
    <AsideComponent v-if="!isMobile && activeNavTab === 'home'" />

    <!-- Footer组件 -->
    <Footer v-if="activeNavTab === 'home'" />

    <!-- 各种弹窗组件 -->
    <FeedbackPopup
      :visible="feedbackPopupState"
      :userInfo="{ username: accountName }"
      @update:visible="feedbackPopupState = $event"
      @showTip="showTipMessage"
      @finish="handleFeedbackSubmitSuccess"
    />

    <SuccessPopup
      v-if="successPopupState"
      :message="successMessage"
      @close="successPopupState = false"
    />

    <V3ScoreDetailPopup v-show="v3PopupState.scoreDetailPopupState" />

    <V3LoginPopup v-show="v3PopupState.loginTipPopupState" />

    <V3TaskRulePopup v-show="v3PopupState.taskPopupState" />

    <V3BagPopup v-show="v3PopupState.bagPopupState" />

    <V3LotterySuccPopup v-show="v3PopupState.lotterySuccPopupState" />

    <KolPopup
      :visible="kolPopupState"
      :userInfo="{ username: accountName }"
      @update:visible="kolPopupState = $event"
      @showTip="showTipMessage"
    />

    <!-- 内容详情弹窗 -->
    <ContentDetailPopup
      :visible="contentDetailPopupState"
      :contentDetail="currentContentDetail"
      :showDeleteButton="isDetailFromCenter"
      @close="handleContentDetailClose"
      @toggleLike="toggleLike"
      @previewImage="previewImage"
      @deleteCreation="showDeleteConfirmFromDetail"
    />

    <!-- 从详情删除的确认弹窗 -->
    <DeleteConfirmPopup
      :visible="deleteConfirmFromDetailState"
      :title="langData.deleteConfirmTitle || '确认删除'"
      :message="
        langData.deleteConfirmText || '确定要删除这个作品吗？删除后无法恢复。'
      "
      :confirmText="langData.confirm || '确定'"
      :cancelText="langData.cancel || '取消'"
      @confirm="confirmDeleteFromDetail"
      @cancel="cancelDeleteFromDetail"
    />

    <!-- 登录提示弹窗 -->
    <LoginTipPopup
      :visible="loginTipPopupState"
      @close="loginTipPopupState = false"
      @login="handleLogin"
    />

    <!-- 创作弹窗 -->
    <CreationPopup
      :visible="createPopupState"
      v-model:createType="createType"
      v-model:createTitle="createTitle"
      v-model:createContent="createContent"
      v-model:createImages="createImages"
      :showingText="submitStatusText"
      @close="hideCreatePopup"
      @submit="handleCreationSubmit"
    />

    <!-- 查看原图弹窗 -->
    <ImagePreviewPopup
      :visible="originalImagePopupState"
      :imageUrl="currentOriginalImage"
      @close="hideOriginalImage"
    />

    <!-- 规则弹窗 -->
    <RulePopup
      :visible="rulePopupVisible"
      :content="rulePopupContent"
      @update:visible="rulePopupVisible = $event"
    />

    <V3TitlePopup v-show="v3PopupState.titlePopupState" />

    <!-- 提示弹窗 -->

    <div class="v3-popup tips-popup" v-show="tipPopupState">
      <div class="v3-popup-mask" @click="tipPopupState = false"></div>
      <div class="v3-popup-content small">
        <div
          class="v3-popup-content-close"
          @click="tipPopupState = false"
        ></div>

        <div class="v3-popup-content-title"></div>
        <div class="v3-popup-content-content">{{ tipPopupContent }}</div>
        <div class="v3-popup-content-footer">
          <div class="confirm-btn btns" @click="tipPopupState = false"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  inject,
  reactive,
  computed,
  onMounted,
  onUnmounted,
  nextTick,
  watch,
  provide,
} from "vue";
import {
  getLoginUrlApi,
  getJSON,
  getActivityApi,
  getLogoutApi,
  getMainHost,
} from "@utils";
import LanguageHook from "@hooks/language";
import { useRulePopup } from "@hooks/usePopup";
import { getMockUgcData } from "@/utils/mockUgcData"; // MOCK 数据

// 导入页面组件
import HomePage from "@/components/pages/HomePage.vue";
import UgcPage from "@/components/pages/UgcPage.vue";
import CenterPage from "@/components/pages/CenterPage.vue";
import CommunicationPage from "@/components/pages/CommunicationPage.vue";
import DevelopmentPage from "@/components/pages/DevelopmentPage.vue";
import FeedbackPage from "@/components/pages/FeedbackPage.vue";

// 导入其他组件
import AsideComponent from "@components/aside.vue";
import FeedbackPopup from "@components/feedbackPopup.vue";
import SuccessPopup from "@components/successPopup.vue";
import KolPopup from "@components/kolPopup.vue";
import RulePopup from "@components/RulePopup.vue";
import Footer from "@components/footer.vue";
import ContentDetailPopup from "@components/contentDetailPopup.vue";
import LoginTipPopup from "@components/loginTipPopup.vue";
import CreationPopup from "@components/creationPopup.vue";
import ImagePreviewPopup from "@components/ImagePreviewPopup.vue";
import DeleteConfirmPopup from "@components/DeleteConfirmPopup.vue";
import MobileTopNavbar from "@components/MobileTopNavbar.vue";
import MobileBottomNavbar from "@components/MobileBottomNavbar.vue";
import V3ScoreDetailPopup from "../components/V3ScoreDetailPopup.vue";
import V3LoginPopup from "../components/V3LoginPopup.vue";
import V3TaskRulePopup from "../components/V3TaskRulePopup.vue";
import V3BagPopup from "../components/V3BagPopup.vue";
import V3LotterySuccPopup from "../components/V3LotterySuccPopup.vue";
import V3TitlePopup from "../components/V3TitlePopup.vue";

import { UgcTab } from "../typings";

// 注入的数据
const isLogin = inject("isLogin", ref(false));
const accountName = inject("accountName", ref(""));

const isMobile = inject("isMobile", ref(false));
const activeNavTab = inject("activeNavTab", ref("home"));
const initClass = inject("initClass", ref(false));
const viewPageStartTime = inject("viewPageStartTime", ref(null));
const updateUrlParam = inject("updateUrlParam", () => {});

// 语言相关
const { curLang, langData } = LanguageHook();

// 规则弹窗 composable
const { rulePopupVisible, rulePopupContent, showRulePopup } = useRulePopup();

// 页面组件已经通过 v-if 直接在模板中使用，不再需要动态组件映射

// 弹窗状态
const feedbackPopupState = ref(false);
const successPopupState = ref(false);
const kolPopupState = ref(false);
const contentDetailPopupState = ref(false);
const loginTipPopupState = ref(false);
const createPopupState = ref(false);
const originalImagePopupState = ref(false);
const currentOriginalImage = ref("");
const tipPopupState = ref(false);
const tipPopupContent = ref("");
const submitStatusText = ref(""); // 提交状态文本

// 其他状态
const successMessage = ref("");
const currentContentDetail = ref(null);
const isDetailFromCenter = ref(false); // 标记详情弹窗是否从个人中心打开
const deleteConfirmFromDetailState = ref(false); // 从详情删除的确认弹窗
const currentDeletingFromDetail = ref(null); // 当前要从详情删除的作品
const participantCount = ref(0);
const musicState = ref(false);

// 内容浏览和创作时长追踪
const contentViewStartTime = ref(null); // 内容详情浏览开始时间
const contentCreationStartTime = ref(null); // 创作弹窗打开时间

// UGC列表相关（供所有组件使用）
const ugcList = ref([]);
const isLoading = ref(false);
const hasMoreData = ref(true);
const activeUgcTab = ref(UgcTab.UgcTypeMyROMemory);
const currentPage = ref(1); // 当前页码
const ugcListIndexMap = ref(new Map()); // ID到索引的映射，用于优化查找
const autoLoadCount = ref(0); // 自动加载计数器，防止无限加载
const MAX_AUTO_LOAD = 3; // 最多自动加载3次，之后由用户滚动触发

// 🔧 开发模式：使用 MOCK 数据测试滚动加载（改为 false 使用真实 API）
// 生产环境（构建产物）强制使用真实 API
const USE_MOCK_DATA =
  import.meta.env.MODE === "development"
    ? false
    : /*TODO：这里可以改为true测试性能问题*/ false;

// 创作相关状态
const createType = ref<UgcTab | "">("");
const createTitle = ref("");
const createContent = ref("");
const createImages = ref([
  { url: "", file: null, id: "img-0" },
  { url: "", file: null, id: "img-1" },
  { url: "", file: null, id: "img-2" },
]);

const lotteryAndTaskState = reactive({
  totalScore: 0, // 用户当前总积分
  historyScore: 0, // 用户历史总积分
  dailyLogin: {
    // 每日登录任务
    state: 0, // 0: 默认状态（立即前往）, 1: 进行中, 2: 已完成
  },
  advanceReservation: {
    // 提前预约
    state: 0,
  },
  joinFb: {
    // 关注Facebook
    state: 0,
  },
  joinDc: {
    // 加入discord
    state: 0,
  },
  joinLine: {
    // 加入Line
    state: 0,
  },
  joinYtb: {
    // 加入YouTube
    state: 0,
  },
  provideFeedback: {
    // 提交意见反馈
    state: 0,
  },
  submitRoMemory: {
    // 我的RO回忆投稿
    state: 0,
    progress: 0,
  },
  submitCostumeDesign: {
    // 时装设计投稿
    state: 0,
  },
  submitPhoto: {
    // 美照分享
    state: 0,
    progress: 0,
  },
  likeOthersUgc: {
    // 为他人作品点赞
    state: 0, // 进行中
    progress: 0,
  },
  likeMyUgc: {
    // 作品收到他人点赞
    state: 0,
    progress: 0,
  },
  isEnd: false,
  titlePopup: {
    title: "",
    color: "",
  },
});

const v3PopupState = reactive({
  loginTipPopupState: false,
  taskPopupState: false,
  bagPopupState: false,
  scoreDetailPopupState: false,
  lotterySuccPopupState: false,
  titlePopupState: false,
});

const lotteryResult = ref([]);

// 创作中心刷新函数的引用（由 CenterPage 设置）
const refreshCenterData = ref(null);

// 提供给子组件的数据
provide("participantCount", participantCount);
provide("lotteryAndTaskState", lotteryAndTaskState);
provide("v3PopupState", v3PopupState);
provide("lotteryResult", lotteryResult);

provide("ugcList", ugcList);
provide("isLoading", isLoading);
provide("hasMoreData", hasMoreData);

provide("activeUgcTab", activeUgcTab);
provide("refreshCenterData", refreshCenterData);

// 事件处理方法
const handleGoBack = () => {
  switchNavTab("home");
};

const showLoginTip = () => {
  loginTipPopupState.value = true;
};

// 提供规则弹窗方法给子组件（向后兼容）
provide("showRulePopup", showRulePopup);

const showCreatePopup = (homePageType: UgcTab | "" = "") => {
  if (!isLogin.value) {
    loginTipPopupState.value = true;
    return;
  }
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "我要发布",
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "发布弹窗",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  // 获取缓存内容
  const createData = localStorage.getItem("createData");
  if (createData) {
    const { type, title, content, images } = JSON.parse(createData);
    createType.value = type as UgcTab | "";
    createTitle.value = title || "";
    createContent.value = content || "";
    createImages.value = (images || []).map((img, index) => ({
      ...img,
      id: img.id || `img-${index}`,
    }));
    // 确保有3个位置
    while (createImages.value.length < 3) {
      const index = createImages.value.length;
      createImages.value.push({ url: "", file: null, id: `img-${index}` });
    }
  }

  // 赋值给homePageType
  if (homePageType) {
    createType.value = homePageType;
  }
  // 滚动到当前页面最上方
  setTimeout(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, 100);

  createPopupState.value = true;

  // 开始计时创作时长
  contentCreationStartTime.value = new Date();
};

const showContentDetail = (item, fromCenter = false) => {
  // window.activityDataLayer.push({
  //   eventName: "click_button",
  //   eventType: "作品详情",
  //   eventReason: "home",
  //   aid: window.activity_name,
  //   gameId: window.game_id,
  // });
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "作品详情弹窗",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  currentContentDetail.value = item;
  isDetailFromCenter.value = fromCenter;
  contentDetailPopupState.value = true;

  // 开始计时内容浏览时长
  contentViewStartTime.value = new Date();
};

// 关闭内容详情弹窗并上报浏览时长
const handleContentDetailClose = () => {
  contentDetailPopupState.value = false;

  // 上报内容浏览时长
  if (contentViewStartTime.value && currentContentDetail.value) {
    const duration = formatDuration(contentViewStartTime.value, new Date());

    // 判断是图文还是纯文字：有图片列表且不为空则是图文，否则是文字
    const hasImages =
      currentContentDetail.value.DISPLAY_PIC_LIST &&
      currentContentDetail.value.DISPLAY_PIC_LIST.length > 0 &&
      currentContentDetail.value.DISPLAY_PIC_LIST.some(
        (img) => img && img.trim()
      );
    const contentType = hasImages ? "图文" : "文字";

    window.activityDataLayer.push({
      eventName: "content_browsing",
      eventType: contentType,
      eventValue: duration,
      aid: window.activity_name,
      gameId: window.game_id,
    });

    contentViewStartTime.value = null;
  }
};

// 显示从详情删除的确认弹窗
const showDeleteConfirmFromDetail = (item) => {
  currentDeletingFromDetail.value = item;
  deleteConfirmFromDetailState.value = true;
};

// 确认从详情删除作品
const confirmDeleteFromDetail = async () => {
  if (!currentDeletingFromDetail.value) return;

  deleteConfirmFromDetailState.value = false;
  contentDetailPopupState.value = false;

  // 调用删除方法
  await deleteCreation(currentDeletingFromDetail.value.ID);

  currentDeletingFromDetail.value = null;
};

// 取消从详情删除
const cancelDeleteFromDetail = () => {
  deleteConfirmFromDetailState.value = false;
  currentDeletingFromDetail.value = null;
};

const showFeedbackPopup = () => {
  feedbackPopupState.value = true;
};

const showKolPopup = () => {
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "加入创作者团队弹窗",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  kolPopupState.value = true;
};

const switchNavTab = async (tab) => {
  // 只支持特定的页面切换
  const supportedPages = ["home", "ugc", "center", "feedback", "development"];
  if (!supportedPages.includes(tab)) {
    console.warn(`不支持的页面: ${tab}`);
    return;
  }

  // 切换到创作中心时需要检查登录状态
  if (tab === "center" && !isLogin.value) {
    showLoginTip();
    return;
  }

  activeNavTab.value = tab;
  initClass();

  // 更新URL参数
  updateUrlParam(tab);
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

  // 如果切换到首页，重新加载视频
  if (tab === "home") {
    await nextTick();
    await videoDelayPlay();
  }

  // 数据埋点
  window.activityDataLayer.push({
    eventName: "click_nav",
    eventType:
      activeNavTab.value === "center"
        ? "创作中心"
        : activeNavTab.value === "ugc"
        ? "UGC列表"
        : activeNavTab.value === "com"
        ? "COM列表"
        : activeNavTab.value === "development"
        ? "开发日志"
        : activeNavTab.value === "feedback"
        ? "意见反馈"
        : "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
};

const gotoLogin = () => {
  const loginUrl = getLoginUrlApi(window.platform_id, window.game_id);
  const link = window.globalGetGotoLink({ link: loginUrl });
  window.open(link, "_self");
};

const checkLogin = () => {
  if (isLogin.value) {
    return true;
  }
  v3PopupState.loginTipPopupState = true;
  return false;
};

const logout = async () => {
  try {
    await getJSON(getLogoutApi(window.platform_id));
    window.location.reload();
  } catch (error) {
    console.error("登出失败:", error);
  }
};

// toggleLike 用于 ContentDetailPopup 的点赞（UGC列表的点赞已移至 UgcPage.vue）
const toggleLike = async (id) => {
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "点赞按钮",
    eventReason: "ugc",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  if (!isLogin.value) {
    loginTipPopupState.value = true;
    return;
  }

  // ContentDetailPopup 的点赞处理
  if (!currentContentDetail.value || currentContentDetail.value.ID !== id) {
    showTipMessage(langData.commonTip || "操作失败");
    return;
  }

  try {
    const { data, result, code } = await getJSON(
      getActivityApi(window.platform_id, window.activity_name, "like"),
      {
        params: JSON.stringify({
          ugcId: id,
          likeType: +currentContentDetail.value.IS_LIKE ? 2 : 1,
        }),
      }
    );

    if (+result === 1) {
      // 切换点赞状态
      currentContentDetail.value.IS_LIKE = +currentContentDetail.value.IS_LIKE
        ? 0
        : 1;

      if (currentContentDetail.value.IS_LIKE) {
        currentContentDetail.value.LIKE_COUNT++;
      } else {
        currentContentDetail.value.LIKE_COUNT = Math.max(
          0,
          currentContentDetail.value.LIKE_COUNT - 1
        );
      }

      // 更新显示的点赞数
      currentContentDetail.value.DISPLAY_LIKE_COUNT =
        +currentContentDetail.value.LIKE_COUNT >= 10000
          ? `${(+currentContentDetail.value.LIKE_COUNT / 10000).toFixed(1)}W`
          : +currentContentDetail.value.LIKE_COUNT >= 1000
          ? `${(+currentContentDetail.value.LIKE_COUNT / 1000).toFixed(1)}K`
          : currentContentDetail.value.LIKE_COUNT;

      // 数据埋点
      // 判断是图文还是纯文字：有图片列表且不为空则是图文，否则是文字
      const hasImages =
        currentContentDetail.value.DISPLAY_PIC_LIST &&
        currentContentDetail.value.DISPLAY_PIC_LIST.length > 0 &&
        currentContentDetail.value.DISPLAY_PIC_LIST.some(
          (img) => img && img.trim()
        );
      const contentType = hasImages ? "图文" : "文字";

      window.activityDataLayer.push({
        eventName: "content_liking",
        eventType: contentType,
        eventValue: JSON.stringify({
          content_likes: currentContentDetail.value.LIKE_COUNT,
          player_account: currentContentDetail.value.LOGIN_ACCOUNT,
          player_uid: currentContentDetail.value.UID,
          content_creation_time: currentContentDetail.value.CREATE_TIME,
        }),
        aid: window.activity_name,
        gameId: window.game_id,
      });
    } else {
      showTipMessage(
        `[${code}]${langData[Math.abs(+code)] || langData.commonTip}`
      );
    }
  } catch (error) {
    console.error("点赞操作失败:", error);
    showTipMessage(langData.commonTip || "操作失败");
  }
};

const deleteCreation = async (id) => {
  try {
    const { data, result, code } = await getJSON(
      getActivityApi(window.platform_id, window.activity_name, "delete"),
      {
        params: JSON.stringify({
          ugcId: id,
        }),
      }
    );

    if (+result === 1) {
      // 删除成功提示
      successMessage.value = langData.deleteSuccess || "删除成功！";
      successPopupState.value = true;

      // 数据埋点
      window.activityDataLayer.push({
        eventName: "click_button",
        eventType: "确认删除作品按钮",
        eventReason: "UGC创作",
        aid: window.activity_name,
        gameId: window.game_id,
      });

      // 1秒后自动关闭成功提示并刷新列表
      setTimeout(() => {
        successPopupState.value = false;
        // 如果当前在创作中心页面且刷新函数存在，则刷新数据
        if (activeNavTab.value === "center" && refreshCenterData.value) {
          refreshCenterData.value();
        }
      }, 1000);
    } else {
      showTipMessage(
        `[${code}]${langData[Math.abs(+code)] || langData.commonTip}`
      );
    }
  } catch (error) {
    console.error("删除失败:", error);
    showTipMessage(langData.commonTip || "删除失败");
  }
};

const previewImage = (imageUrl) => {
  currentOriginalImage.value = imageUrl;
  originalImagePopupState.value = true;
  console.log("预览图片:", imageUrl);
};

const hideOriginalImage = () => {
  originalImagePopupState.value = false;
  currentOriginalImage.value = "";
};

const handleFeedbackSubmit = (feedbackData) => {
  // 处理反馈提交
  console.log("提交反馈:", feedbackData);
  feedbackPopupState.value = false;
  successMessage.value = langData.feedbackSubmitSuccess;
  successPopupState.value = true;
};

const handleFeedbackSubmitSuccess = () => {
  feedbackPopupState.value = false;
  successMessage.value = langData.publishSuccess;
  successPopupState.value = true;
};

const showTipMessage = (message) => {
  tipPopupContent.value = message;
  tipPopupState.value = true;
};

const showCurErrorTips = (code) => {
  let curMessage = `[${code}]${
    langData[Math.abs(+code)] || langData.commonTip
  }`;
  console.log("curMessage", curMessage);
  showTipMessage(curMessage);
};

const handleSendMessage = (message) => {
  // 处理发送消息
  console.log("发送消息:", message);
};

const handleToggleMessageLike = (messageId, isLiked) => {
  // 处理消息点赞
  console.log("消息点赞:", messageId, isLiked);
};

const handleLogin = () => {
  loginTipPopupState.value = false;
  gotoLogin();
};

// 处理创作提交
const handleCreationSubmit = async (creationData) => {
  try {
    // 显示提交中状态
    submitStatusText.value = langData.submitting || "提交中...";

    await submitCreationAPI(creationData);

    // 显示提交成功状态
    submitStatusText.value = langData.submitSuccess || "提交成功！";
    await initActivity();
    // 等待一下让用户看到成功提示
    setTimeout(() => {
      // 清空状态文本
      submitStatusText.value = "";

      // 上报创作时长
      reportCreationTime();

      // 关闭创作弹窗
      createPopupState.value = false;

      // 显示成功弹窗
      successMessage.value = langData.publishSuccess;
      successPopupState.value = true;

      // 清空表单
      resetCreateForm();
    }, 1000);
  } catch (error) {
    console.error("提交创作失败:", error);
    submitStatusText.value =
      error.message || langData.submitFailed || "提交失败，请重试";

    // 2秒后清空错误提示
    setTimeout(() => {
      submitStatusText.value = "";
    }, 2000);
  }
};

// 移动端相关方法
const jumpLink = (link, name, module) => {
  if (link) {
    window.open(link, "_blank");
    window.activityDataLayer.push({
      eventName: "click_button",
      eventType: name,
      eventReason: module,
      aid: window.activity_name,
      gameId: window.game_id,
    });
  }
};

const switchMusic = () => {
  musicState.value = !musicState.value;
  // 这里可以添加音乐播放/暂停逻辑
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
};

// 视频延迟播放函数
const videoDelayPlay = async () => {
  let tpl = "";
  if (isMobile.value) {
    tpl = `<source src="https://gevents.${getMainHost()}/rolk_vedio/home-video_m.mp4" type="video/mp4">
    <source src="https://gevents.${getMainHost()}/rolk_vedio/home-video_m.webm" type="video/webm">`;
  } else {
    // PC端视频逻辑
    tpl = `<source src="https://gevents.${getMainHost()}/rolk_vedio/home-video.mp4" type="video/mp4">
    <source src="https://gevents.${getMainHost()}/rolk_vedio/home-video.webm" type="video/webm">`;
  }

  const video = document.getElementById("index-video");
  if (video) {
    video.innerHTML = tpl;
    video.addEventListener("canplay", () => {
      const container = document.querySelector("#video-container");
      if (container) {
        container.classList.add("active");
      }
      video.play();
    });
  }
};

const goUgcList = async (autoOpen = false) => {
  await switchNavTab("ugc");
  if (autoOpen) {
    showCreatePopup();
  }
};

const goCenter = async () => {
  await switchNavTab("center");
};

const initActivity = async () => {
  // 获取活动数据
  let activityRes = await getJSON(
    getActivityApi(window.platform_id, window.activity_name, "basicV2"),
    {
      params: JSON.stringify({}),
    }
  );
  if (+activityRes.result) {
    participantCount.value = activityRes?.data?.joinCount || 0;
    lotteryAndTaskState.totalScore = activityRes?.data?.totalScore || 0;
    lotteryAndTaskState.historyScore = activityRes?.data?.historyScore || 0;
    lotteryAndTaskState.dailyLogin.state =
      activityRes?.data?.dailyLogin.state || 0;
    lotteryAndTaskState.advanceReservation.state =
      activityRes?.data?.advanceReservation.state || 0;
    lotteryAndTaskState.joinFb.state = activityRes?.data?.joinFb.state || 0;
    lotteryAndTaskState.joinDc.state = activityRes?.data?.joinDc.state || 0;
    lotteryAndTaskState.joinLine.state = activityRes?.data?.joinLine.state || 0;
    lotteryAndTaskState.joinYtb.state = activityRes?.data?.joinYtb.state || 0;
    lotteryAndTaskState.provideFeedback.state =
      activityRes?.data?.provideFeedback.state || 0;
    lotteryAndTaskState.submitRoMemory.state =
      activityRes?.data?.submitRoMemory.state || 0;
    lotteryAndTaskState.submitRoMemory.progress =
      activityRes?.data?.submitRoMemory.progress || 0;
    lotteryAndTaskState.submitCostumeDesign.state =
      activityRes?.data?.submitCostumeDesign.state || 0;
    lotteryAndTaskState.submitPhoto.state =
      activityRes?.data?.submitPhoto.state || 0;
    lotteryAndTaskState.submitPhoto.progress =
      activityRes?.data?.submitPhoto.progress || 0;
    lotteryAndTaskState.likeOthersUgc.state =
      activityRes?.data?.likeOthersUgc.state || 0;
    lotteryAndTaskState.likeOthersUgc.progress =
      activityRes?.data?.likeOthersUgc.progress || 0;
    lotteryAndTaskState.likeMyUgc.state =
      activityRes?.data?.likeMyUgc.state || 0;
    lotteryAndTaskState.likeMyUgc.progress =
      activityRes?.data?.likeMyUgc.progress || 0;
    lotteryAndTaskState.isEnd = activityRes?.data?.isEnd || false;
  }
};

const submitTask = async (taskId) => {
  const res = await getJSON(
    getActivityApi(
      window.platform_id,
      window.activity_name,
      "followTaskCallback"
    ),
    {
      params: JSON.stringify({ taskId }),
    }
  );
  if (+res.result != 1) {
    showCurErrorTips(res.code);
    return;
  }
};

// 初始化
const init = async () => {
  try {
    // 视频延迟播放
    await videoDelayPlay();
    await initActivity();
  } catch (error) {
    console.error("获取活动数据失败:", error);
  }
};

// 生命周期
onMounted(() => {
  init();
  // 注意：滚动监听已由 VirtualGrid 组件处理，这里不需要再监听
});

onUnmounted(() => {
  // 注意：滚动监听已由 VirtualGrid 组件处理，这里不需要清理
});

// 上报创作时长
const reportCreationTime = () => {
  if (contentCreationStartTime.value && createType.value) {
    const duration = formatDuration(contentCreationStartTime.value, new Date());
    const contentType = getUgcTypeText(createType.value);

    window.activityDataLayer.push({
      eventName: "content_creation",
      eventType: contentType,
      eventValue: duration,
      aid: window.activity_name,
      gameId: window.game_id,
    });

    contentCreationStartTime.value = null;
  }
};

// 创作弹窗相关方法
const hideCreatePopup = () => {
  // 如果有未保存的内容，显示确认弹窗
  if (
    createTitle.value ||
    createContent.value ||
    createImages.value.some((image) => image.url)
  ) {
    // 这里可以添加确认保存弹窗逻辑
    console.log("有未保存的内容");
  }

  // 上报创作时长
  reportCreationTime();

  createPopupState.value = false;
};

// 真实API提交函数
const submitCreationAPI = async (creationData) => {
  // 这里实现真实的API调用
  const { data, result, code } = await getJSON(
    getActivityApi(window.platform_id, window.activity_name, "submit"),
    {
      params: JSON.stringify({
        ugcType: creationData.type,
        ugcTitle: encodeURIComponent(encodeURIComponent(creationData.title)),
        ugcContent: encodeURIComponent(encodeURIComponent(creationData.content)),
        picList: creationData.images
          .filter((item) => item.url)
          .map((item) => item.url)
          .join(","),
      }),
    }
  );

  if (+result !== 1) {
    // throw new Error(`API Error: [${code}] ${data?.msg || 'Unknown error'}`);
    throw new Error(langData[Math.abs(+code)] || langData.commonTip);
  }

  return data;
};

// 重置创作表单
const resetCreateForm = () => {
  createType.value = "";
  createTitle.value = "";
  createContent.value = "";
  createImages.value = [
    { url: "", file: null, id: "img-0" },
    { url: "", file: null, id: "img-1" },
    { url: "", file: null, id: "img-2" },
  ];
  localStorage.removeItem("createData");
};

// 监听导航变化
watch(activeNavTab, (newTab, oldTab) => {
  console.log(`导航从 ${oldTab} 切换到 ${newTab}`);
});

// 辅助函数：获取UGC类型文本
const getUgcTypeText = (type) => {
  return +type === 1
    ? langData.createType1 || "时装设计"
    : +type === 2
    ? langData.createType2 || "头饰设计"
    : langData.createType3 || "造梗活动";
};

// 计算浏览时长
const formatDuration = (startTime, endTime) => {
  const duration = Math.floor((endTime - startTime) / 1000); // 转换为秒
  // 格式化为 xxHxxMxxS
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;
  return `${hours > 0 ? hours + "H" : ""}${
    minutes > 0 ? minutes + "M" : ""
  }${seconds}S`;
};

const jumpToWebsite = () => {
  const link = window.globalGetGotoLink(
    "https://gwww.gnjoy.hk/official_website/index.html?name=rolk&store=0"
  );
  window.open(link, "_blank");
};

const jumpToFacebook = () => {
  window.open("https://www.facebook.com/ROWorld.Gravity/", "_blank");
};

const jumpToDiscord = () => {
  window.open("https://discord.gg/zZV3fdHDb7", "_blank");
};

// 加载UGC数据
const loadUgcData = async (
  ugcType = 4,
  orderBy = "new",
  publishTime = "",
  keyword = "",
  page = 1,
  pageSize = 12
) => {
  isLoading.value = true;
  try {
    await loadRealUgcData(
      ugcType,
      orderBy,
      publishTime,
      keyword,
      page,
      pageSize
    );
  } catch (error) {
    console.error("加载UGC数据失败:", error);
  } finally {
    isLoading.value = false;
  }

  // 加载完成后检查是否需要继续加载（页面高度不足时）
  await checkIfNeedLoadMore();
};

// 数据处理函数 - 只处理新数据，避免重复处理
const processUgcData = (rawData) => {
  return rawData.map((item) => ({
    ...item,
    // 保留前2个字符及后1个字符
    DISPLAY_LOGIN_ACCOUNT:
      item?.LOGIN_ACCOUNT?.length > 3
        ? item?.LOGIN_ACCOUNT?.slice(0, 2) +
          "..." +
          item?.LOGIN_ACCOUNT?.slice(-1)
        : item?.LOGIN_ACCOUNT,
    // 调整展示 大于1千显示千位 大于1万显示万位
    DISPLAY_LIKE_COUNT:
      +item?.LIKE_COUNT >= 10000
        ? `${(+item?.LIKE_COUNT / 10000).toFixed(1)}W`
        : +item?.LIKE_COUNT >= 1000
        ? `${(+item?.LIKE_COUNT / 1000).toFixed(1)}K`
        : item?.LIKE_COUNT,
    DISPLAY_TITLE:
      item?.TITLE?.length > 10
        ? item?.TITLE?.slice(0, 10) + "..."
        : item?.TITLE,
    DISPLAY_CONTENT:
      item?.CONTENT?.length > 10
        ? item?.CONTENT?.slice(0, 10) + "..."
        : item?.CONTENT,
    // 图片列表
    DISPLAY_PIC_LIST: item?.PIC_URL_LIST ? item?.PIC_URL_LIST?.split(",") : [],
    DISPLAY_PIC:
      item?.PIC_URL_LIST && item?.PIC_URL_LIST?.split(",")[0]
        ? item?.PIC_URL_LIST?.split(",")[0]
        : import.meta.env.BASE_URL + `default-pic-${item.ID % 6 + 1}.png`,
    // 使用ID生成稳定的头像ID，而不是随机（避免每次重新渲染）
    DISPLAY_AVATAR_ID: (item.ID % 6) + 1,
  }));
};

// 更新索引映射
const updateUgcIndexMap = () => {
  ugcListIndexMap.value.clear();
  ugcList.value.forEach((item, index) => {
    ugcListIndexMap.value.set(item.ID, index);
  });
};

// 真实API数据加载函数
const loadRealUgcData = async (
  ugcType,
  orderBy,
  publishTime,
  keyword,
  page,
  pageSize
) => {
  let data, result, code;

  // 开发模式：使用 MOCK 数据
  if (USE_MOCK_DATA) {
    const mockResponse = await getMockUgcData({
      params: JSON.stringify({
        ugcType: ugcType,
        orderBy: orderBy,
        publishTime: publishTime,
        keyword: keyword,
        page: page,
        pageSize: pageSize,
      }),
    });
    data = mockResponse.data;
    result = mockResponse.result;
    code = mockResponse.code;
  } else {
    // 使用真实 API
    const response = await getJSON(
      getActivityApi(window.platform_id, window.activity_name, "ugcList"),
      {
        params: JSON.stringify({
          ugcType: ugcType,
          orderBy: orderBy,
          publishTime: publishTime,
          keyword: keyword,
          page: page,
          pageSize: pageSize,
        }),
      }
    );
    data = response.data;
    result = response.result;
    code = response.code;
  }

  if (+result === 1) {
    const rawList = data?.ugcContentList || [];
    // 只处理新数据
    const processedData = processUgcData(rawList);

    if (page === 1) {
      ugcList.value = processedData;
      currentPage.value = 1;
      autoLoadCount.value = 0; // 重置自动加载计数器
    } else {
      ugcList.value = [...ugcList.value, ...processedData];
      currentPage.value = page;
    }

    // 更新索引映射
    updateUgcIndexMap();

    hasMoreData.value = rawList.length === pageSize;
  } else {
    console.error(`API Error: [${code}] ${data?.msg || "Unknown error"}`);
  }
};

// 检查是否需要加载更多数据（页面高度不足时自动加载）
const checkIfNeedLoadMore = async () => {
  // 只在UGC页面时才检查
  if (activeNavTab.value !== "ugc") return;

  // 如果正在加载或没有更多数据，则不处理
  if (isLoading.value || !hasMoreData.value) return;

  // 限制自动加载次数，避免无限加载
  if (autoLoadCount.value >= MAX_AUTO_LOAD) return;

  // 等待DOM更新
  await nextTick();

  // 检查页面是否有滚动条
  const hasVerticalScrollbar =
    document.documentElement.scrollHeight > window.innerHeight;

  // 如果没有滚动条，说明内容不够，继续加载
  if (!hasVerticalScrollbar) {
    autoLoadCount.value++;
    await loadMoreUgcData();
  }
};

// 滚动加载逻辑（已弃用，现在由 VirtualGrid 组件的 reachBottom 事件处理）
// const handleScroll = async () => {
//   if (activeNavTab.value !== 'ugc') return;
//   if (isLoading.value || !hasMoreData.value) return;
//   const container = document.querySelector('.ugc-list');
//   if (!container) return;
//   const items = container.querySelectorAll('.ugc-item');
//   if (items.length === 0) return;
//   const itemsPerRow = isMobile.value ? 2 : 4;
//   const lastRowStartIndex = Math.floor((items.length - 1) / itemsPerRow) * itemsPerRow;
//   const lastRowFirstItem = items[lastRowStartIndex];
//   if (!lastRowFirstItem) return;
//   const rect = lastRowFirstItem.getBoundingClientRect();
//   if (rect.top < window.innerHeight + 200) {
//     await loadMoreUgcData();
//   }
// };

// 加载更多UGC数据
const loadMoreUgcData = async () => {
  if (isLoading.value || !hasMoreData.value) return;

  const nextPage = currentPage.value + 1;

  // 使用当前的筛选条件加载下一页
  await loadUgcData(
    activeUgcTab.value,
    "new", // 默认使用最新排序，如果需要可以从UgcPage传递参数
    "",
    "",
    nextPage,
    12
  );
};

// 提供数据和函数给子组件
provide("loadUgcData", loadUgcData);
provide("loadMoreUgcData", loadMoreUgcData); // 提供加载更多函数（虚拟滚动使用）
provide("ugcListIndexMap", ugcListIndexMap); // 提供索引映射
provide("checkLogin", checkLogin);
provide("gotoLogin", gotoLogin);
provide("initActivity", initActivity);
provide("submitTask", submitTask);
provide("goUgcList", goUgcList);
provide("goCenter", goCenter);
provide("showFeedbackPopup", showFeedbackPopup);
provide("showCurErrorTips", showCurErrorTips);
provide("showTipMessage", showTipMessage);
</script>

<style lang="less">
@import url(../assets/less/index.less);
@import url(../assets/less/home.less);

.slider-wrapper {
  transition: transform 0.3s ease-out;
}

/* 滑动中的状态，可以通过v-bind动态添加 */
.slider-wrapper.dragging {
  transition: none;
}

.slider-slide {
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  img {
    pointer-events: none;
    /* 防止拖动图片而不是滑动轮播图 */
  }
}

.feedback-btn {
  width: 660px;
  height: 130px;
  cursor: pointer;
  background: url(../assets/images/home/feedback.png) center/contain no-repeat;
  margin: 20px 0;
}

/* 开发日志页面样式 */
.development-log-buttons {
  position: absolute;
  top: 230px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 20px 0;
}

.qa-btn,
.log-btn {
  width: 240px;
  height: 120px;
  cursor: pointer;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: opacity 0.3s ease;
}

.qa-btn {
  background-image: url(../assets/images/sub-page/qa-btn.png);
}

.log-btn {
  background-image: url(../assets/images/sub-page/log-btn.png);
}

.qa-btn:not(.active),
.log-btn:not(.active) {
  opacity: 0.6;
}

.qa-btn:hover,
.log-btn:hover {
  opacity: 1;
}

.development-log-page {
  width: 100%;
  height: auto;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top;
  background-color: #fffdf1;
  &.isMobile {
    padding-bottom: 200px;
    &.qa-page {
      background-image: url(../assets/images/sub-page/qa-page_m.jpg);
      height: 10000px;
    }
    &.log-page {
      background-image: url(../assets/images/sub-page/log-page_m.jpg);
      height: 1800px;
    }
  }
}

.development-log-page.qa-page {
  background-image: url(../assets/images/sub-page/qa-page.jpg);
  height: 8100px;
}

.development-log-page.log-page {
  background-image: url(../assets/images/sub-page/log-page.jpg);
  height: 1780px;
}

// 过渡动画样式
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
